import { render, staticRenderFns } from "./NewsEdit.vue?vue&type=template&id=09461186"
import script from "./NewsEdit.vue?vue&type=script&lang=js"
export * from "./NewsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports